module.exports = __webpack_public_path__ + "img/DTP-box.95236f80.svg";